import { GetServerSideProps } from "next";

const apiBaseUrl = process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL;
let sitemapBaseUrl: any = process.env.NEXT_PUBLIC_SITEMAP_BASE_URL;

// Ensure the base URL has a trailing slash
if (!sitemapBaseUrl.endsWith("/")) {
  sitemapBaseUrl += "/";
}

// Maps a services-2025 "parent" display name to its URL segment (mirrors services/[slug]/index.tsx)
const SERVICE_PARENT_MAP: Record<string, string> = {
  "CRM Services": "crm-services",
  "AI software services": "ai-services",
  "Software Services": "software-services",
  "Enterprise Platform Solutions": "enterprise-platforms-solutions",
};

const generateServicesSiteMap = (serviceUrls: string[]) => {
  return `<?xml version="1.0" encoding="UTF-8"?>
    <?xml-stylesheet type="text/xsl" href="${sitemapBaseUrl}main-sitemap.xsl"?>
    <urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
        ${serviceUrls
          .map(
            (url: string) => `
                <url>
                    <loc>${url}</loc>
                    <changefreq>weekly</changefreq>
                    <priority>0.8</priority>
                </url>
                `
          )
          .join("")}
    </urlset>`;
};

export const getServerSideProps: GetServerSideProps = async ({ res }) => {
  try {
    const request = await fetch(`${apiBaseUrl}all-pages`);
    const slugs = await request.json();

    let serviceUrls: string[] = [];

    (slugs?.services || []).forEach((slug: string) => {
      serviceUrls.push(`${sitemapBaseUrl}services/${slug}`);
    });

    (slugs?.["services-2025"] || []).forEach((item: any) => {
      if (!item?.slug) return;
      if (item.template === "ChildService" && item.parent) {
        const parentSegment =
          SERVICE_PARENT_MAP[item.parent] ||
          String(item.parent).toLowerCase().replace(/\s+/g, "-");
        serviceUrls.push(
          `${sitemapBaseUrl}services/${parentSegment}/${item.slug}`
        );
      } else {
        serviceUrls.push(`${sitemapBaseUrl}services/${item.slug}`);
      }
    });

    serviceUrls = Array.from(new Set(serviceUrls));

    const sitemap = generateServicesSiteMap(serviceUrls);

    res.setHeader("Content-Type", "text/xml");
    res.write(sitemap);
    res.end();
  } catch (error) {
    console.error("Error generating Services sitemap:", error);
    res.statusCode = 500;
    res.end();
  }

  return { props: {} };
};

export default function ServicesSiteMap() {}
